import {Component, OnInit} from '@angular/core';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {environment} from '~/environments/environment';
import {AuthenticationService} from '@services/authentification.service';
import {HttpClient} from '@angular/common/http';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';
import {UserService} from '@services/user.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmComponent} from '@components/popup/confirm/confirm.component';

@Component({
    selector: 'app-plan-api',
    templateUrl: './plan-api.component.html',
    styleUrls: ['./plan-api.component.scss']
})
export class PlanApiComponent implements OnInit {
    user: User = Object.assign({}, EMPTY_USER);
    stripe = Stripe(environment.stripeKey);

    success = '';
    error = '';
    loading = false;

    plans = [
        {
            id: 'api_starter',
            name: 'Starter',
            price: 249,
            credits: 10000,
            color: 'essentiel',
            pricePerCredit: '0,025'
        },
        {
            id: 'api_pro',
            name: 'Pro',
            price: 599,
            credits: 30000,
            color: 'expert',
            pricePerCredit: '0,020'
        },
        {
            id: 'api_business',
            name: 'Business',
            price: 1499,
            credits: 90000,
            color: 'basique',
            pricePerCredit: '0,017'
        }
    ];

    getPlanLabel(): string {
        const labels = {
            'api_starter': 'Starter',
            'api_pro': 'Pro',
            'api_business': 'Business',
            'api_enterprise': 'Entreprise',
        };
        return labels[this.user.api_plan] || this.user.api_plan;
    }

    packPrices: { [key: string]: number } = {
        '': 60,
        'api_starter': 30,
        'api_pro': 25,
        'api_business': 20,
        'api_enterprise': 15,
    };

    creditCostsAd = [
        {name: 'Annonce seule (ad)', cost: 1},
        {name: 'Calculs de rentabilité (calc)', cost: 7},
        {name: 'Données INSEE ville (city_insee)', cost: 5},
        {name: 'Loyers ville (city_loyer)', cost: 5},
        {name: 'Prix immobilier ville (city_prix)', cost: 5},
    ];

    creditCostsCity = [
        {name: 'Données ville complètes (/api/city/{city_code})', cost: 20},
    ];

    constructor(
        public authenticationService: AuthenticationService,
        private http: HttpClient,
        private alertService: AlertService,
        private route: ActivatedRoute,
        public trackingService: TrackingService,
        private userService: UserService,
        private dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
        this.success = this.route.snapshot.queryParams.success || '';
        this.error = this.route.snapshot.queryParams.error || '';
        this.user = this.authenticationService.currentUser;
    }

    scrollToPlan() {
        document.getElementById('plan')?.scrollIntoView({behavior: 'smooth', block: 'center'});
    }

    getPackPrice(): number {
        return this.packPrices[this.user.api_plan] || this.packPrices[''];
    }

    planSelect(plan: string) {
        if (this.loading) {
            return;
        }

        this.loading = true;
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
            {plan, duration: 'month'}).subscribe(
            session => {
                this.trackingService.checkout({value: plan});
                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
                this.loading = false;
                this.alertService.error('Erreur');
            });
    }

    updateCB() {
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-update-checkout-session`, {}).subscribe(
            session => {
                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
            });
    }

    cancelApiPlan(): void {
        const dialogRef = this.dialog.open(ConfirmComponent, {
            width: '450px',
            data: {message: 'Êtes-vous sûr de vouloir résilier votre forfait API ?'}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.userService.cancelApiPlan().subscribe(
                    () => {
                        window.location.reload();
                    },
                    () => {
                        this.alertService.error('Une erreur est survenue, veuillez réessayer.');
                    }
                );
            }
        });
    }

    buyPack() {
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
            {plan: 'api_pack', duration: 'once'}).subscribe(
            session => {
                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
                this.loading = false;
                this.alertService.error('Erreur');
            });
    }
}
